import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Full } from '../../components/Footer/Full.js';
import { Short } from '../../components/Footer/Short.js';
import { ShortWithLinks } from '../../components/Footer/ShortWithLinks.js';
export const Footer = props => {
  if (props.kind === 'short') {
    return _jsx(Short, {
      brandName: props.brandName
    });
  }
  if (props.kind === 'shortWithLinks') {
    return _jsx(ShortWithLinks, {
      brandName: props.brandName,
      path: props.path,
      shortLinks: props.config.shortLinks
    });
  }
  return _jsx(Full, {
    path: props.path || '',
    links: props.config.links,
    socialLinks: props.config.socialLinks,
    brandName: props.brandName
  });
};